module.exports = {
      id: "kishoralo-white-usage",
      viewBox: "0 0 512 209.4",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#kishoralo-white",
      toString: function () {
        return this.url;
      }
    }